var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('el-button',{staticClass:"image-batch-download-btn",attrs:{"type":"text","size":_vm.size,"loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f51470","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageBatchDownloadBtn.vue
// module id = 2BJt
// module chunks = 1